import { useState, useEffect } from 'react';
import { commitMutation, graphql, useRelayEnvironment } from 'react-relay';
import { Transition } from '@headlessui/react';
import { Error } from '@/core/alerts';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';

const simulatorMutation = graphql`
  mutation resumeSimulatorSpacePublicMutation (
    $category: String,
    $spaceRef: String,
    $riderRef: String,
    $riders:Int,
    $datesSelected: JSONObject) {
    simulatorSpacePublicMutation(category: $category, spaceRef: $spaceRef, riderRef: $riderRef, riders: $riders, datesSelected: $datesSelected) {
      days
      price {
        excl_tax
      }
      priceByDates {
        excl_tax
        incl_tax
      }
      riderFees {
        excl_tax
        incl_tax
      }
      riderOwing {
        excl_tax
        incl_tax
      }
    }
  }
`;

const runSimulatorMutation = (environment, variables, callback) => {
  commitMutation(
    environment,
    {
      mutation: simulatorMutation,
      variables,
      onCompleted: (res) => {
        if (!res?.simulatorSpacePublicMutation?.days) return callback(null, null);
        return callback(null, res.simulatorSpacePublicMutation);
      },
      onError: (err) => {
        console.error(err);
        return callback(true);
      },
    },
  );
};

function SpacePublicSimulatorResume() {
  const [category] = useState('production');
  const datesSelected = useSpacePublicZustandStore((state) => state.datesSelected);
  const riders = useSpacePublicZustandStore((state) => state.riders);
  const { spaceRef } = useSpacePublicZustandStore.getState();
  const environment = useRelayEnvironment();

  const [dataState, setDataState] = useState({
    data: null,
    status: null,
  });

  const run = () => {
    runSimulatorMutation(environment, {
      category,
      riders,
      spaceRef,
      datesSelected,
    }, (err, res) => {
      // console.log(res);
      dataState.status = null;
      dataState.data = null;

      if (err) dataState.status = <Error text="error simu" />;
      else {
        dataState.data = res;
      }
      setDataState({ ...dataState });
    });
  };

  useEffect(() => {
    if (category) {
      setDataState({ data: null, status: null });
    }
  }, [category]);
  useEffect(() => {
    if (category && Object.keys(datesSelected).length) {
      // console.log('run resume');
      run();
    } else {
      setDataState({ data: null, status: null });
    }
  }, [datesSelected, riders]);

  return (!dataState.data
    || dataState.status || (
    <>
      <div className="flex justify-between py-2 pt-4 border-b border-white-dark2">
        <div className="text-dark">
          {`${dataState?.data?.price?.excl_tax}€ x ${dataState?.data?.days}j`}
          {' '}
          <span>
            (
            {riders}
            {' '}
            pers.)
          </span>
        </div>
        <div className="font-medium">{`${dataState?.data?.priceByDates?.excl_tax}€`}</div>
      </div>
      {(() => {
        if (dataState?.data?.riderFees?.excl_tax > 0) {
          return (
            <div className="flex justify-between py-2 border-b border-white-dark2">
              <div className="text-dark">Frais</div>
              <div className="font-medium">{`${dataState?.data?.riderFees?.excl_tax}€`}</div>
            </div>
          );
        }

        return null;
      })()}
      <div className="flex justify-between pt-2 text-right border-white-dark2">
        <div className="font-medium text-[16px]">Total</div>
        <div className="font-medium text-[16px] text-purple">
          {`${dataState?.data?.riderOwing?.excl_tax}€`}
          <span className="block text-[14px] font-normal text-dark">
            {`${dataState?.data?.riderOwing?.incl_tax}€`}
            {' '}
            TTC
          </span>
        </div>
      </div>
    </>
  )
  );
}

export default SpacePublicSimulatorResume;
